import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'localDate'
})
export class LocalDatePipe implements PipeTransform {
  transform(value: string | Date, format: string = 'DD/MM/YYYY hh:mm A'): string {
    if (!value) {
      return '';
    }

    const date = moment(value);
    if (!date.isValid()) {
      return '';
    }

    return date.format(format);
  }
}
